module.exports = __webpack_public_path__ + "img/blog-cover-video-vs-reels.e476eddd.webp";